import * as React from 'react'
import * as ReactDOM from 'react-dom/client'
import { HandleReactComponentRendering } from '@ClientBase/React/RenderReactComponents'
import { declareClientPackage, RuntimeDetails } from '@ClientBase/IClientPackage'
import { JobFiltersEventHandler } from '@ClientBase/Generic/JobFiltersEventHandler'
import * as Navigation from './Navigation'
import * as SiteSwitcher from './SiteSwitcher'
import * as Shortlist from './Shortlist'
import * as Carousels from './Carousels'
import * as JobFilters from './JobFilters'
import * as BlogFilters from './BlogFilters'
import * as JobAlerts from './JobAlerts'
import * as HomeVideo from './HomeVideo'
import * as Modal from './Modal'
import SnippetSpacer from './Spacer/Spacer'
import SnippetDivider from './Divider/Divider'
import SnippetHeading from './Heading/Heading'
import SnippetContent from './Content/Content'
import SnippetImageContent from './ImageContent/ImageContent'
import SnippetContentColumn from './ContentColumn/ContentColumn'
import SnippetGeneralCarousel from './GeneralCarousel/GeneralCarousel'
import SnippetLinkBox from './LinkBox/LinkBox'
import SnippetTabSwitcher from './TabSwitcher/TabSwitcher'
import SnippetStatistics from './Statistics/Statistics'
import SnippetStatisticsPercent from './StatisticsPercent/StatisticsPercent'
import SnippetStatisticsIcon from './StatisticsIcon/StatisticsIcon'
import SnippetAccordion from './Accordion/Accordion'
import SnippetVideo from './Video/Video'
import SnippetPvp from './Pvp/Pvp'
import SnippetTimeline from './Timeline/Timeline'
import SnippetImageContentIcon from './ImageContentIcon/ImageContentIcon'
import SnippetQuickLinks from './QuickLinks/QuickLinks'
import SnippetImage from './Image/Image'
import SnippetDualColumnContent from './DualColumnContent/DualColumnContent'
import SnippetBentoStatistics from './BentoStatistics/BentoStatistics'
import SnippetImageGallery from './ImageGallery/ImageGallery'
import * as WorkflowDefault from "@ClientBase/Generic/WorkFlowStyling"
import Workflow from './Workflow'
import * as PostAlert from './PostAlert'

/**
 * Extend the ClientBase class so you can benefit from any event hooks that Attrax offers,
 * and so that Attrax knows you have defined specific methods
 */

const _Components = {
    'SnippetSpacer': SnippetSpacer,
    'SnippetDivider': SnippetDivider,
    'SnippetHeading': SnippetHeading,
    'SnippetContent' : SnippetContent,
    'SnippetImageContent': SnippetImageContent,
    'SnippetContentColumn': SnippetContentColumn,
    'SnippetGeneralCarousel': SnippetGeneralCarousel,
    'SnippetLinkBox': SnippetLinkBox,
    'SnippetTabSwitcher': SnippetTabSwitcher,
    'SnippetStatistics' : SnippetStatistics,
    'SnippetStatisticsPercent' : SnippetStatisticsPercent,
    'SnippetStatisticsIcon' : SnippetStatisticsIcon,
    'SnippetAccordion' : SnippetAccordion,
    'SnippetVideo' : SnippetVideo,
    'SnippetPvp' : SnippetPvp,
    'SnippetTimeline' : SnippetTimeline,
    'SnippetImageContentIcon' : SnippetImageContentIcon,
    'SnippetQuickLinks' : SnippetQuickLinks,
    'SnippetImage' : SnippetImage,
    'SnippetDualColumnContent' : SnippetDualColumnContent,
    'SnippetBentoStatistics' : SnippetBentoStatistics,
    'SnippetImageGallery' : SnippetImageGallery,
}

declareClientPackage({
    onCmsSnippetPreview() {
        HandleReactComponentRendering(React, ReactDOM, _Components)
    },
    onDocumentReady(details: RuntimeDetails) {
        HandleReactComponentRendering(React, ReactDOM, _Components)
        Navigation.initialise()
        HomeVideo.initialise()
        Shortlist.initialise()
        SiteSwitcher.initialise()
        JobFilters.initialise()
        BlogFilters.initialise()
        Carousels.initialise()
        JobFiltersEventHandler.useAttraxTsHandlers($)
        Modal.closeModalOnBgClick()
        WorkflowDefault.HandleIntegratedWorkflows()
        Workflow.initialise()
        JobAlerts.initialise()
        PostAlert.initialise()
        $(document).on('job-filter-initialized', function () {
            (window as any).jobFilterNoReloadController.enableDefaultFilterCounts()
        })
    }
})
